import type { StoredUsers } from '~/gql/users/users'
import { useMutation } from '@apollo/client/react'
import { useTranslation } from 'react-i18next'
import { toast } from 'sonner'
import { Button } from '~/components/ui/button'
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '~/components/ui/dialog'
import { GQL_DELETE_USER } from '~/gql/users/users'

type IProps = {
  open: boolean
  onCancel: () => void
  onSuccess: () => void
  user: StoredUsers
}

function UserDeleteModal({ open, onCancel, onSuccess, user }: IProps) {
  const { t } = useTranslation()

  const [deleteUser] = useMutation(GQL_DELETE_USER)

  const handleDeleteUser = async () => {
    try {
      await deleteUser({ variables: { id: user.id } })
      toast.success(t('good.delete.user'))
      onSuccess()
      onCancel()
    } catch {
      toast.error(t('bad.delete.user'))
      onCancel()
    }
  }

  return (
    <Dialog open={open} onOpenChange={onCancel}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{t('delete.user')}</DialogTitle>
          <DialogDescription>
            {t('delete.user.first-message')}
            <br />
            <span className="font-bold">{t('delete.second-message')}</span>
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button variant="outline" onClick={onCancel}>
            {t('common.cancel')}
          </Button>
          <Button variant="destructive" onClick={handleDeleteUser}>
            {t('common.delete')}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}

export default UserDeleteModal
